import React, { Component } from 'react';
import Layout from '../components/layout';
import { Button } from 'reactstrap';
import iconcard from "../images/iconcard.svg";
import iconkey from "../images/iconkey.svg";
import iconstar from "../images/iconstar.svg";

const packages = [{
    iconName: iconstar,
    title: 'SIMPLY GOOD',
    price: '$69',
    duration: 'per person',
    moreDetail: true,
    moreContent: "Not a member? That's ok, book a session now for only $69.",
    btnText: 'Book now',
    btnColor: "red",
    key: 'plan_simple'
}, {
    iconName: iconkey,
    title: 'CLUB',
    price: '$49',
    duration: 'per month',
    moreDetail: true,
    moreContent: ['One time $99 activation fee includes two facials (a $138 value).',
                  '$49/month: includes one facial plus 30% off all other facials that month.',
                  'Cancel anytime with no penalties on our easy app.',
                  'Priority waitlist status when schedule is fully booked.',
                  "Forget about us? We won't forget about you. If we haven't seen you in three months, charges are automatically suspended."],
    btnText: 'Join the club',
    btnColor: "teal",
    key: 'plan_club'
}, {
    iconName: iconcard,
    title: 'GIFT THE FACIAL',
    price: '',
    duration: 'Give someone you love the gift of a one-of-a-kind facial.',
    btnText: 'Buy a gift card',
    btnColor: "success"
}];

const features = ['HYDRATE', 'POLISH', 'ANTI-ACNE', 'EXFOLIATE', 'SPOTS REMOVAL'];

export default class Pricing extends Component {
    state = {
        plan_simple: false,
        plan_club: false
    };

    togglePrice = (type) => {
        this.setState(state => ({
            [type]: !state[type]
        }));
    }

    render() {
        return (
            <Layout>
                <main className="pricing">
                    <h2 className='text-uppercase text-center my-5'>Pricing</h2>

                    {/* pricing types */}
                    <section className='container d-flex flex-column flex-md-row justify-content-center flex-wrap'>
                        {packages.map(item => {
                            return (
                                <div className='pricing-cntr px-3 pb-5' key={item.title}>
                                    <div className="alert text-center">
                                        <img className='icon' src={item.iconName} alt='iconstar' width='50' height='50'/>
                                        <h4>{item.title}</h4>
                                    </div>

                                    <div className="alert text-center d-flex flex-column justify-content-between content pt-5">
                                        <div>
                                            <h4 className='mb-0 price'>{item.price}</h4>
                                            <p className='font-small mb-2'>{item.duration}</p>

                                            {item.moreDetail && <>
                                                <p className='font-weight-bold font-small mb-4 more' onClick={() => {this.togglePrice(item.key); }}>See Details +</p>

                                                {this.state[item.key] &&
                                                    <div className="more-content">
                                                        {Array.isArray(item.moreContent)
                                                            ? <ul>
                                                                {item.moreContent.map((description, key) => {
                                                                    return <li key={`desc_${key}`}>{description}</li>
                                                                    })}
                                                                </ul>
                                                            :  <div className='more-content'>
                                                                <div>{item.moreContent}</div>
                                                              </div>
                                                          }
                                                    </div>
                                                }
                                            </>}
                                        </div>
                                        <Button color={item.btnColor} size="lg" className="text-uppercase font-regular">{item.btnText}</Button>
                                    </div>
                                </div>
                            )
                        })}
                    </section>

                    <div className='add-ons px-3'>
                        <h2 className='text-uppercase text-center font-weight-bold'>free add-ons</h2>
                        <p className='text-center mt-3 font-regular'>Add any of the below services to a FaceX facial at no additional cost.</p>

                        <div className='container'>
                            <div className="d-flex flex-md-row flex-column justify-content-between feature">
                                {features.map(feature => (<strong key={feature}>{feature}</strong>))}
                            </div>
                        </div>
                    </div>
                </main>
            </Layout>
        )
    }
};
